import React, {PureComponent} from 'react'
import { connect } from 'react-redux';
import classnames from 'classnames';

import Analytics from './../../analytics';
import {setGalleryActiveImageIndex, toggleGalleryVisible} from "../../actions/selectionFunctions";
import {featureThumbnailUrl} from "../../misc/helpers";
import {THUMBNAIL_SIZES} from "../../misc/utils";

class GalleryViewClass extends PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      images: [],
      galleryOpened: false
    };
  }

  componentDidMount() {
    const {activeFeature, galleryImages} = this.props;
    this.setState({
      images: [{
        id: 1,
        url: featureThumbnailUrl(activeFeature),
        preview: featureThumbnailUrl(activeFeature, THUMBNAIL_SIZES.medium)
      },  // main image thumbnail
        ...galleryImages
      ]
    });
    setTimeout(() => {
      this.setState({
        galleryOpened: true
      });
    }, 0)
  }

  componentWillUnmount() {
    this.props.setGalleryActiveImageIndex(0);
  }

  handleCloseClick = () => {
    Analytics.sendClickEvent('gallery-close');
    this.setState({
      galleryOpened: false
    }, () => {
      setTimeout(() => {
        this.props.toggleGalleryVisible(false);
      }, 300)
    })
  };

  thumbnailClick = (activeImage, activeImageIndex) => {
    Analytics.sendClickEvent('view-gallery-image-' + activeImage.id)
    this.props.setGalleryActiveImageIndex(activeImageIndex)
  };

  render() {
    const activeImage = this.state.images[this.props.galleryActiveImageIndex];
    return (
      <div className="gallery-overlay" onClick={this.handleCloseClick}>
        <div className={"gallery-view" + (this.state.galleryOpened ? " gallery-view--opened" : "")}
             onClick={(e) => e.stopPropagation()}>
          <div className="gallery-view--close" onClick={this.handleCloseClick}>
          </div>
          <div className="gallery-view__main">
            {activeImage
              ? <img src={activeImage.url}
                     alt={activeImage.name}
                     onClick={() => window.open(activeImage.url, "_blank")}
                     className="gallery-view__main-image" />
              : null}
          </div>
          <div className="gallery-view__footer">
            <ul className="gallery-view__footer-list">
              {this.state.images.map((g, gIndex) => {
                return (
                  <li key={g.id} style={{backgroundImage: "url('" + (g.preview || g.url) + "')"}}
                      className={classnames("gallery-view__footer-list-image",
                        {"gallery-view__footer-list-image--active": this.props.galleryActiveImageIndex === gIndex})}
                      onClick={() => this.thumbnailClick(g, gIndex)}/>
                )
              })}
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (store) => {
  let { galleryActiveImageIndex, selectionFeatureInfo, galleryShowActiveFeature, activeFeature} = store.selectionState;
  const showFeature = galleryShowActiveFeature ? galleryShowActiveFeature : selectionFeatureInfo || activeFeature;
  return {
    galleryImages: showFeature.dbFeature.galleryImages || [],
    galleryActiveImageIndex,
    activeFeature: showFeature,
  };
};

export default connect(mapStateToProps, {
  toggleGalleryVisible,
  setGalleryActiveImageIndex
})(GalleryViewClass);
